module.exports = __webpack_public_path__ + "static/img/腾讯元器小程序.74fae4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/腾讯元器小程序.png
// module id = wZmw
// module chunks = 1